import isEqual from 'lodash/isEqual';
import repeatTypes from './repeatTypes';

const parseRepeatType = (repeat = {}) => (
  repeat.type ||
  Object.keys(repeatTypes).find(repeatType => isEqual(repeat.weekly, repeatTypes[repeatType]))
);

export default parseRepeatType;
